// The public figures map (16 October 2026): one solar system per political movement.
// Never a number of mentions or authors: shares. A person's gender is never guessed
// ("those who talk about {a}", never "about him"). Never how it is measured.
// Percentages go through `commun.pourcent`.
export default {
  vue: { aria: 'Directory view', liste: 'List', carte: 'Map' },
  sousTitre: '{n} public figures in {systemes} systems, from the left to the right of the chamber',
  chargement: 'Drawing the map…',
  vide: 'No public figures in this country’s directory yet.',
  scene: {
    galaxie: 'The galaxy of movements: one system per movement, followed figures linked by the audience they share',
    systeme: 'The {nom} system: its figures in orbit, by rank',
  },
  kicker: 'Political galaxy · {pays}',
  titre: { galaxie: 'One system per movement' },
  // The number of figures in a system: never mentions.
  effectif: '{n} figure | {n} figure | {n} figures',
  repere: { gauche: 'Left', droite: 'Right' },
  soleil: {
    aria: '{sigle}, {nom}: {effectif}. Enter the system',
    centre: 'around {nom}',
  },
  systeme: {
    retour: 'Whole galaxy',
    retourAria: 'Back to the whole galaxy',
    sansCentre: 'no central star: the directory ties them to no movement',
  },
  orbite: {
    direction: 'Leadership',
    executif: 'Executive',
    territoires: 'Regions and cities',
    europe: 'European Parliament',
    AN: 'National Assembly',
    SENAT: 'Senate',
    autre: 'Other offices',
  },
  // What the directory files under no movement: these system names are translated.
  residuel: {
    gouvernement: { sigle: 'Gov.', nom: 'Government' },
    territoires: { sigle: 'Reg.', nom: 'Regions and major cities' },
    'non-inscrits': { sigle: 'NI', nom: 'Non-attached' },
    autres: { sigle: 'Other', nom: 'Other parties' },
    'sans-etiquette': { sigle: '?', nom: 'No known affiliation' },
  },
  planete: {
    suivie: 'Followed',
    centre: 'Central star',
    ouvrir: '{nom}. Open the profile',
    ouvrirSuivie: '{nom}, followed. See their score and audience',
  },
  legende: {
    aria: 'Map legend',
    soleil: 'A movement, sized by its number of figures',
    suivie: 'Followed figure',
    tete: 'Movement leader',
    lien: 'Shared audience: the thicker the line, the more it is shared',
    orbites: 'Within a system, from the centre outwards: the central star (the movement’s leader), the leadership, the executive, regions and cities, the European Parliament, the National Assembly, the Senate.',
  },
  suivies: {
    titre: 'Your followed figures',
    aucune: 'Follow a figure from the list or their profile: they light up here, linked to those who share their audience.',
    ecouteFermee: 'Shared audiences are available with figure following.',
    liens: 'No shared audience between your followed figures yet | One shared audience between your followed figures | {n} shared audiences between your followed figures',
  },
  panneau: {
    voirSysteme: 'See their system',
    ouvrirFiche: 'Open the profile',
    ecouteFermee: 'Their score, who talks about them and their shared audience are available with figure following.',
    note: 'Score',
    surCent: 'out of 100',
    evolution: '{n} over 7 days',
    sansNote: 'No score yet: the first listening is under way.',
    personas: 'Who talks about them',
    aucunPersona: 'The groups of those who talk about them take shape after a few days of listening.',
    portrait: 'A face of the “{nom}” group',
    recoupements: 'Their audience, shared',
    recoupement: '{n}% of those who talk about {a} also talk about {b}',
    inverse: 'and {n}% the other way round',
    personasProches: 'Similar personas',
    memePersona: '“{nom}” on both sides',
    deuxPersonas: '“{a}” and “{b}”',
    aucunRecoupement: 'Not enough audience shared with your other followed figures over the last {jours} days to speak of a shared audience.',
    pasEncore: 'Not enough listening yet to measure their audience.',
    seule: 'Follow another figure to see the audience they share.',
  },
}
